// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-0cbe408e]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.coupon_content .margin[data-v-0cbe408e] {\n  margin: 16px 0;\n}\n.coupon_content .warning[data-v-0cbe408e] {\n  color: #999;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
